import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { clear } from '@App/store/actions/similarity';

class SimilaritySearchUrl extends Component {
    static propTypes = {
        url: PropTypes.string.isRequired,
        remove: PropTypes.func.isRequired,
    };

    render() {
        const { url, remove } = this.props;

        return (
            <div className="search-items--item similarity-search-url">
                {url}
                <button className="search-items--remove" type="button" onClick={remove}>
                    <i className="icon icon--clear"></i>
                </button>
            </div>
        );
    }
}

export default connect(
    null,
    dispatch => ({
        remove: () => dispatch(clear()),
    })
)(SimilaritySearchUrl);
